import { Component, ViewChild, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckbox, MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  imports: [MatButtonModule, MatCheckboxModule, IconComponent],
  selector: 'app-custom-remove-button',
  templateUrl: './custom-remove-button.component.html',
})
export class CustomRemoveButtonComponent {
  public readonly checked = input<boolean>(false);
  public readonly disabled = input<boolean>(false);
  public readonly buttonClass = input<string>('mat-secondary-transparent-button-color');

  public readonly checkboxStateChanged = output<MatCheckboxChange>();

  @ViewChild('checkbox', { static: false })
  public checkbox!: MatCheckbox;

  public get isChecked(): boolean {
    return this.checkbox ? this.checkbox.checked : this.checked();
  }

  public onButtonClick(event: Event, checkbox: MatCheckbox): void {
    event.stopPropagation();

    this.checkboxStateChanged.emit({
      checked: !checkbox.checked,
      source: checkbox as unknown as MatCheckbox,
    } as MatCheckboxChange);
    checkbox.toggle();
  }
}
